import { PoNumberConfiguration, PoNumberForm } from '../../../../fields'
import {CreateFormInput} from '../types'

export const buildPoNumberForm = ({
  order
}: CreateFormInput<PoNumberConfiguration>): PoNumberForm => {
  return {
    poNumber: order.customerReference ?? ''
  }
}
